import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import { Grid } from "@mui/material";
import { useContext, useEffect } from "react";
import { ProviderProjectDashboard } from "../ProjectSupportDashboard";


const ProjectPieChartUnitType = () => {

  const {
    lstProjectUnitTypeChart,
    nEventUnitType,
    setnEventUnitType,
    lstUnitTypeChartSub,
  } = useContext(ProviderProjectDashboard);

  useEffect(() => {
    PieChartUnittype();
    PieChartUnittypeSub();
  }, [lstProjectUnitTypeChart, nEventUnitType, lstUnitTypeChartSub])

  const PieChartUnittype = () => {

    am4core.addLicense("CH208466903"); //รหัสรายเส้นใช้ไม่ให้ขึ้นเส้นโลโก้

    // Create chart instance
    let chart = am4core.create("PieChartUnittype", am4charts.PieChart3D);

    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    chart.legend = new am4charts.Legend();

    const arrData = lstProjectUnitTypeChart.map((item) => {
      let resultData = {
        "sUnitName": item.sUnitName,
        "nProjectTotal": item.nProjectTotal,
        "nProjectPriceTotal": item.nProjectPrice,
        "nUnitTypeID": item.nUnitTypeID,
      };
      return resultData;
    });
    chart.data = arrData


    let pieSeries = chart.series.push(new am4charts.PieSeries3D());
    pieSeries.dataFields.value = "nProjectPriceTotal";
    pieSeries.dataFields.category = "sUnitName";
    pieSeries.slices.template.tooltipText = "{sUnitName}: จำนวนเงิน {value} บาท  มี {nProjectTotal} โครงการ ({value.percent.formatNumber('#.00')}%)";
    pieSeries.tooltip.label.maxWidth = 500;
    pieSeries.tooltip.label.wrap = true;
    pieSeries.labels.template.maxWidth = 140;
    pieSeries.labels.template.wrap = true;
    pieSeries.slices.template.events.on("hit", function (event) {
      let ObjData: PieChartUnittype = {};
      ObjData = event.target.dataItem.dataContext
      let ObjProblem = {
        nUnitTypeID: ObjData.nUnitTypeID,
      };
      setnEventUnitType(ObjProblem.nUnitTypeID);
    });
  }

  const PieChartUnittypeSub = () => {

    am4core.addLicense("CH208466903"); //รหัสรายเส้นใช้ไม่ให้ขึ้นเส้นโลโก้

    // Create chart instance
    let chart = am4core.create("PieChartUnittypeSub", am4charts.PieChart3D);

    chart.hiddenState.properties.opacity = 0; // this creates initial fade-in
    // chart.legend = new am4charts.Legend();

    const arrData = lstUnitTypeChartSub.filter(f => f.nUnitTypeID === nEventUnitType).map((item) => {
      let resultData = {
        "sProjectName": item.sProjectName,
        "nProjectPriceTotal": item.nProjectPrice,
        "nUnitTypeID": item.nUnitTypeID,
      };
      return resultData;
    });
    chart.data = arrData

    // Add and configure Series
    // let pieSeries = chart.series.push(new am4charts.PieSeries3D());
    // pieSeries.dataFields.value = "nProjectPriceTotal";
    // pieSeries.dataFields.category = "sProjectName";
    // pieSeries.slices.template.strokeWidth = 2;
    // pieSeries.slices.template.strokeOpacity = 1;
    // pieSeries.ticks.template.disabled = true;
    // pieSeries.labels.template.disabled = true;
    // pieSeries.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
    // pieSeries.tooltip.label.maxWidth = 500;
    // pieSeries.tooltip.label.wrap = true;
    let pieSeries = chart.series.push(new am4charts.PieSeries3D());
    pieSeries.dataFields.value = "nProjectPriceTotal";
    pieSeries.dataFields.category = "sProjectName";
    pieSeries.slices.template.tooltipText = "{category}: {value} ({value.percent.formatNumber('#.00')}%)";
    pieSeries.tooltip.label.maxWidth = 500;
    pieSeries.tooltip.label.wrap = true;
    pieSeries.labels.template.text = "{value} ({value.percent.formatNumber('#.00')}%)";
   

    // This creates initial animation
    pieSeries.hiddenState.properties.opacity = 1;
    pieSeries.hiddenState.properties.endAngle = -90;
    pieSeries.hiddenState.properties.startAngle = -90;
  }

  return (
    <>
      {nEventUnitType === 0 &&
        <Grid item xs={12} md={12}>
          <div id="PieChartUnittype" style={{ width: "100%", height: "450px" }}></div>
        </Grid>
      }
      {nEventUnitType !== 0 &&
        <Grid item xs={12} md={12}>
          <div id="PieChartUnittypeSub" style={{ width: "100%", height: "450px" }}></div>
        </Grid>
      }
    </>
  )
}
export default ProjectPieChartUnitType

export interface PieChartUnittype {
  nUnitTypeID?: number;

}